// src/pages/b2b/B2BDashboardPage.js - 대시보드 페이지 (더미)

import React from 'react';
import B2BLayout from '../../components/b2b/B2BLayout';
import { usePageHeader } from '../../context/PageHeaderContext';
import './B2BDashboardPage.scss';

const B2BDashboardPage = () => {
  usePageHeader({
    title: '대시보드',
    subtitle: '전체 현황을 한눈에 확인하세요',
    showBack: false,
  });

  return (
    <B2BLayout hideCollapseButton={false}>
      <div className="b2b-dashboard-page">
        <div className="b2b-page-content">
          <div className="b2b-placeholder">
            <p>준비 중입니다...</p>
          </div>
        </div>
      </div>
    </B2BLayout>
  );
};

export default B2BDashboardPage;

